import MUIDataTable from "mui-datatables";
import { useNavigate } from "react-router";

export const ScraperLogsTable = ({
	logs,
	page,
	rowsCount,
	count,
	handlePage,
	handleRowsCount,
}) => {
	const navigate = useNavigate();

	const columns = [
		{
			name: "scraper_run_id",
			label: "Log ID",
			options: {
				setCellProps: () => ({ style: { textAlign: "center" } }),
				filter: false,
				sort: false,
			},
		},

		{
			name: "sum_of_playoffs_products",
			label: "No of Products Scraped",
			options: {
				setCellProps: () => ({ style: { textAlign: "center" } }),
				filter: false,
				sort: false,
				customBodyRender: (value) => {
					return value;
				},
			},
		},

     {
      name: "sum_of_unsuccessful_scraped_product",
      label: "No of Products failed to Scrape",
      options: {
        setCellProps: () => ({ style: { textAlign: "center" } }),
        filter: false,
        sort: false,
        customBodyRender: (value) => {
          return value;
        },
      },
    },

    // {
    //   name: "total_scraped_products",
    //   label: "No of Products Modified",
    //   options: {
    //     setCellProps: () => ({ style: { textAlign: "center" } }),
    //     filter: false,
    //     sort: false,
    //     customBodyRender: (value) => {
    //       return value;
    //     },
    //   },
    // },
    {
      name: "total_created",
      label: "Created Products",
      options: {
        setCellProps: () => ({ style: { textAlign: "center" } }),
        filter: false,
        sort: false,
        // customBodyRender: (value) => {
        //   return value;
        // },
 
				customBodyRender: (value, tableMeta) => {
          const playoffIndex = columns.findIndex(col => col.name === "playoff");
          console.log("INDEX::::::::::::",playoffIndex)
					const playoff = tableMeta.rowData[playoffIndex]; // column index of "playoff"
					if (playoff && playoff.length > 0) {
						return 0; // force to 0 when playoff exists
					}
					return value;
				},
			},
		},
		{
			name: "total_updated",
			label: "Updated Products",
			options: {
				setCellProps: () => ({ style: { textAlign: "center" } }),
				filter: false,
				sort: false,
				customBodyRender: (value) => {
					return value;
				},
			},
		},
		{
			name: "total_deactivated",
			label: "Out Of Stock Products",
			options: {
				setCellProps: () => ({ style: { textAlign: "center" } }),
				filter: false,
				sort: false,
				customBodyRender: (value) => {
					return value;
				},
			},
		},
		{
			name: "playoff",
			label: "Scope",
			options: {
				setCellProps: () => ({
					style: { textAlign: "center", fontSize: "14px" },
				}),

				filter: false,
				sort: false,
				customBodyRender: (value) => {
					if (!value || value.length === 0) {return "Global";}

					if (Array.isArray(value)) {
						const filtered = value.filter(Boolean);
						return filtered.length > 1
							? "All Playoffs"
							: "Playoff: [ " + filtered + " ]";
					}

					return value;
				},
			},
		},
		{
			name: "last_updated_at",
			label: "Created At",
			options: {
				setCellProps: () => ({ style: { textAlign: "center" } }),
				filter: false,
				sort: false,
				customBodyRender: (value) =>
					value ? new Date(value).toLocaleString() : "-",
			},
		},
	];

	const options = {
		selectableRows: "none",
		onRowClick: (rowData, rowMeta) => {
			const rowIndex = rowMeta.dataIndex; // index in the original data array
			const fullRow = logs[rowIndex]; // full object with all fields
			console.log("FULL ROW DATA", fullRow);
			// const scraper_ids = rowData[4]; // assuming ID is first column
			navigate(
				`/w86zjruk6q/product_logs?scraper_id=${fullRow.scraper_ids}`,
				{
					state: {
						scraperId: fullRow.scraper_ids,
						scraper_run_id: fullRow.scraper_run_id,
					},
				}
			);
		},

		responsive: "standard",
		elevation: 0,

		jumpToPage: true,

		download: false,
		filter: false,
		serverSide: true,
		print: false,
		count: count,
		page: page,
		rowsPerPage: rowsCount,
		rowsPerPageOptions: [10, 25, 100],
		onChangePage: handlePage, // use prop
		onChangeRowsPerPage: handleRowsCount, // use prop
	};

	return (
		<MUIDataTable
			title="Scraper Logs"
			data={logs}
			columns={columns}
			options={options}
		/>
	);
};
